<div class="flex gap-3 rounded-lg border border-slate-100 bg-slate-50 p-3">
  <div class="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-slate-500">
    <app-icon class="inline-flex !h-[18px] !w-[18px] items-center justify-center !text-[18px] !leading-[18px]">comment</app-icon>
  </div>
  <div class="min-w-0 flex-1">
    <div class="flex flex-wrap items-center justify-between gap-2">
      <div class="min-w-0">
        <div class="truncate text-sm font-semibold text-slate-800">{{ 'comment' | translate }}</div>
        <div class="mt-0.5 flex min-w-0 items-center gap-1.5">
          <app-avatar
            size="16px"
            [title]="getTimelineAuthorName()"
            [url]="getTimelineAuthorAvatarUrl()"
            [isPhotoGallery]="false"
          />
          <span class="truncate text-xs font-medium text-slate-500">{{ getTimelineAuthorName() }}</span>
        </div>
      </div>

      <div class="flex shrink-0 items-center gap-2">
        <span class="text-xs text-slate-400">{{ event.created_at | date: 'dd MMM HH:mm' }}</span>

        @if (!isEditing && !readonly) {
          <button
            type="button"
            class="flex h-6 w-6 items-center justify-center rounded text-slate-400 hover:bg-slate-100 hover:text-slate-600"
            [attr.aria-label]="'timeline_comment_actions' | translate"
            [cdkMenuTriggerFor]="actionsMenu"
          >
            <app-icon class="!h-4 !w-4 !text-[16px] !leading-4">more_vert</app-icon>
          </button>
        }
      </div>
    </div>

    @if (isEditing) {
      <div class="mt-2">
        <app-input [inputType]="'editor'" [formControl]="commentControl" />
        <div class="mt-2 flex justify-end gap-2">
          <app-button btnType="stroked" [disabled]="savingComment" (onChangeClick)="onCancelEdit()">
            {{ 'cancel' | translate }}
          </app-button>
          <app-button [disabled]="!commentControl.value?.trim() || savingComment" (onChangeClick)="onSaveEdit()">
            {{ 'save' | translate }}
          </app-button>
        </div>
      </div>
    } @else if (getCommentHtml(); as commentHtml) {
      <div
        class="mt-2 text-sm text-slate-600 [&_li]:mb-1 [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:pl-5"
        [innerHTML]="commentHtml"
      ></div>
    }
  </div>
</div>

<ng-template #actionsMenu>
  <div cdkMenu class="min-w-40 rounded-xl border border-gray-100 bg-white p-1.5 shadow-lg">
    <button
      type="button"
      cdkMenuItem
      class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-slate-700 hover:bg-slate-50"
      (click)="onEditClick()"
    >
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-4 text-slate-400">edit</app-icon>
      {{ 'timeline_comment_edit_action' | translate }}
    </button>
    <button
      type="button"
      cdkMenuItem
      class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-red-600 hover:bg-red-50"
      (click)="onDeleteClick()"
    >
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-4 text-red-500">delete</app-icon>
      {{ 'timeline_comment_delete_action' | translate }}
    </button>
  </div>
</ng-template>
